import createContext from 'contexts/create-context';
import * as React from 'react';

import { CreateIncassoAction, ICreateIncassoState, createIncassoReducer } from './reducer';

interface ProviderValue {
  state: ICreateIncassoState;
  dispatch: React.Dispatch<CreateIncassoAction>;
}

const [useContext, ReactProvider] = createContext<ProviderValue>();

export const CreateIncassoProvider: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;
  const [state, dispatch] = React.useReducer(createIncassoReducer, {
    activeWindow: 'SELECT_CUSTOMER',
    selectedCustomer: null,
    selectedInvoices: [],
  });

  return <ReactProvider value={{ state, dispatch }}>{children}</ReactProvider>;
};

export const useCreateIncassoCtx = useContext;
